const initials = "paymentVerify/";

export const UPDATE_PAYMENT_RESULTS = `${initials}UPDATE_PAYMENT_RESULTS`;

export const CLEAR_PAYMENT_RESULTS = `${initials}CLEAR_PAYMENT_RESULTS`;
